import { Chip, Stack } from '@mui/material';
import { DataTable, type Column } from '../../components/DataTable';
import { SrbCode } from '../../components/SrbCode';
import { StatusChip } from '../../components/StatusChip';
import { toneColor } from '../../components/tone';
import { ModeIcon, RouteText } from './ShipmentCard';
import { useApprovalsFor } from '../approvals/useApprovals';
import { STAGE_TONE, type Shipment } from './sample';

const columns = (approvalsFor: (srb: string) => number): Column<Shipment>[] => [
  { header: 'SRB', primary: true, nowrap: true, render: (s) => <SrbCode code={s.srb} /> },
  { header: 'Customer', render: (s) => s.customer },
  { header: 'Route', render: (s) => <RouteText s={s} /> },
  { header: 'Mode', nowrap: true, render: (s) => <ModeIcon mode={s.mode} /> },
  { header: 'Type', nowrap: true, render: (s) => s.mode },
  { header: 'Stage', nowrap: true, render: (s) => <StatusChip label={s.stage} tone={STAGE_TONE[s.stage]} /> },
  { header: 'Next Action', render: (s) => s.next.text },
  {
    header: 'Deadline',
    nowrap: true,
    render: (s) => <span style={{ color: toneColor(s.next.tone), fontWeight: 600 }}>{s.next.due}</span>,
  },
  { header: 'ETD', nowrap: true, render: (s) => s.etd },
  { header: 'ETA', nowrap: true, render: (s) => s.eta },
  {
    header: 'Approvals',
    action: true,
    render: (s) => {
      const n = approvalsFor(s.srb);
      return <Chip size="small" color={n ? 'error' : 'default'} label={n} />;
    },
  },
  { header: 'Last Update', nowrap: true, render: (s) => s.updated },
];

export function ShipmentsTable({ rows }: { rows: Shipment[] }) {
  const approvalsFor = useApprovalsFor();
  return (
    <Stack>
      <DataTable rows={rows} columns={columns(approvalsFor)} rowKey={(s) => s.srb} empty="No shipments match." />
    </Stack>
  );
}
